<template>
  <div class="navbar">
    <div class="navbar-content">
      <!-- Área do Logo -->
      <div class="navbar-left">
        <div class="logo-area">
          <img src="@/assets/img/logo-black.png" alt="LubConsulta" class="logo">
        </div>
      </div>

      <!-- Área Central - Breadcrumb e Botão Sidebar -->
      <div class="navbar-center">
        <div class="breadcrumb">
          <button class="sidebar-toggle" @click="toggleSidebar">
            <span class="toggle-icon">☰</span>
          </button>
        </div>
        
        <!-- Botão Sidebar Toggle -->
        
      </div>

      <!-- Perfil -->
      <div class="navbar-right">
        <div class="navbar-profile" @click="toggleProfileMenu">
          <div class="profile-avatar">
            <img src="@/assets/img/ico.png" alt="Profile" class="avatar">
          </div>
          <div>
            <span class="profile-name">Minha Conta</span>
          </div>
          <span class="profile-arrow" :class="{ rotated: showProfileMenu }">▼</span>
        </div>
        
        <div v-if="showProfileMenu" class="profile-menu">
          <div class="profile-menu-header">
            <div class="profile-menu-avatar">
              <img src="@/assets/img/ico.png" alt="Profile" class="avatar-large">
            </div>
            <div class="profile-menu-info">
              <div class="profile-menu-name">Usuário Admin</div>
              <div class="profile-menu-email">admin@lubconsulta.com</div>
            </div>
          </div>
          <div class="profile-menu-items">
            <div class="profile-menu-item">
              <span class="menu-item-icon">👤</span>
              <span class="menu-item-label">Meu Perfil</span>
            </div>
            <div class="profile-menu-item">
              <span class="menu-item-icon">⚙️</span>
              <span class="menu-item-label">Configurações</span>
            </div>
            <div class="profile-menu-divider"></div>
            <div class="profile-menu-item logout" @click="logout">
              <span class="menu-item-icon">🚪</span>
              <span class="menu-item-label">Sair</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppNavbar',
  data() {
    return {
      showProfileMenu: false,
      isSidebarCollapsed: false
    }
  },
  methods: {
    toggleSidebar() {
      this.isSidebarCollapsed = !this.isSidebarCollapsed;
      // Emitir o evento para o componente pai (LayoutPrincipal)
      this.$emit('toggle-sidebar', this.isSidebarCollapsed);
    },
    toggleProfileMenu() {
      this.showProfileMenu = !this.showProfileMenu;
    },
    logout() {
      if (confirm('Tem certeza que deseja sair?')) {
        console.log('Logout realizado');
      }
    }
  },
  mounted() {
    document.addEventListener('click', (e) => {
      if (!this.$el.contains(e.target)) {
        this.showProfileMenu = false;
      }
    });
  }
}
</script>

<style scoped>
.navbar {
  background: #152730;
  border-bottom: 1px solid #334155;
  height: 70px;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.navbar-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
  padding: 0 2rem;
}

/* Área da Logo */
.navbar-left {
  display: flex;
  align-items: center;
}

.logo-area {
  display: flex;
  align-items: center;
}

.logo {
  width: 200px;
  height: 35px;
  border-radius: 0px;
}

/* Área Central - Breadcrumb e Botão Sidebar */
.navbar-center {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 2rem;
}

.breadcrumb {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  font-family: 'Roboto', sans-serif;
  font-size: 0.7rem;
}

.breadcrumb-item {
  color: #cbd5e1;
  font-weight: 500;
}

.breadcrumb-item.active {
  color: white;
  font-weight: 600;
}

.breadcrumb-separator {
  color: #94a3b8;
  font-weight: 300;
}

/* Botão Sidebar Toggle */
.sidebar-toggle {
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 8px;
  color: white;
  font-size: 1.25rem;
  cursor: pointer;
  padding: 0.5rem;
  transition: all 0.3s ease;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-toggle:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

/* Área do Perfil */
.navbar-right {
  position: relative;
}

.navbar-profile {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.5rem 1rem;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: rgba(255, 255, 255, 0.05);
  border: 0px solid rgba(255, 255, 255, 0.1);
}

.navbar-profile:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
}

.profile-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.profile-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 380;
  color: white;
  font-size: 0.775rem;
}

.profile-email {
  font-family: 'Roboto', sans-serif;
  color: #cbd5e1;
  font-size: 0.75rem;
}

.profile-avatar .avatar {
  width: 16px;
  height: 16px;
  object-fit: cover;
}

.profile-arrow {
  transition: transform 0.3s ease;
  font-size: 0.75rem;
  color: #cbd5e1;
}

.profile-arrow.rotated {
  transform: rotate(180deg);
}

.profile-menu {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 0.5rem;
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.2);
  border: 1px solid #e2e8f0;
  width: 280px;
  z-index: 1001;
}

.profile-menu-header {
  padding: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
  display: flex;
  align-items: center;
  gap: 1rem;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
}

.avatar-large {
  width: 50px;
  height: 50px;
  border-radius: 10px;
  object-fit: cover;
}

.profile-menu-info {
  flex: 1;
}

.profile-menu-name {
  font-family: 'Roboto', sans-serif;
  font-weight: 38;
  color: #1e293b;
  margin-bottom: 0.25rem;
}

.profile-menu-email {
  font-family: 'Roboto', sans-serif;
  color: #64748b;
  font-size: 0.775rem;
}

.profile-menu-items {
  padding: 0.5rem;
}

.profile-menu-item {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Roboto', sans-serif;
  color: #475569;
}

.profile-menu-item:hover {
  background: #f1f5f9;
  color: #1e293b;
}

.profile-menu-item.logout {
  color: #dc2626;
}

.profile-menu-item.logout:hover {
  background: #fef2f2;
}

.menu-item-icon {
  font-size: 1.125rem;
  width: 20px;
  text-align: center;
}

.menu-item-label {
  font-weight: 500;
}

.profile-menu-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 0.5rem 0;
}

/* Responsivo */
@media (max-width: 1024px) {
  .navbar-center {
    padding: 0 1rem;
  }
  
  .breadcrumb {
    font-size: 0.8rem;
  }
}

@media (max-width: 768px) {
  .navbar-content {
    padding: 0 1rem;
  }
  
  .logo {
    width: 150px;
  }
  
  .breadcrumb {
    display: none;
  }
  
  .navbar-center {
    justify-content: flex-end;
  }
  
  .profile-info {
    display: none;
  }
  
  .navbar-profile {
    padding: 0.5rem;
  }
}
</style>